/* istanbul ignore next */
export var BlocksCSSLinkManager = {
    CreatedCSSLinks: [],
    AllCSSLinks: [],
    CSSLinksContainerID: "css-links-container",
    CSSLinksContainer: null,
    getLinksContainer: function () {
        if (this.CSSLinksContainer === null) {
            this.CSSLinksContainer = document.createElement("div");
            this.CSSLinksContainer.id = this.CSSLinksContainerID;
            document.body.appendChild(this.CSSLinksContainer);
        }
        return this.CSSLinksContainer;
    },
    createCSSLinks: function (cssLinks) {
        var _this = this;
        cssLinks && cssLinks.forEach(function (link) {
            if (!_this.CreatedCSSLinks.find(function (l) { return l.name === link.name || l.href === link.href; })) {
                _this.CreatedCSSLinks.push(link);
                setTimeout(function () {
                    var linkEl = document.createElement("link");
                    linkEl.rel = "stylesheet";
                    linkEl.href = link.href;
                    _this.getLinksContainer().appendChild(linkEl);
                }, 0);
            }
        });
        return this.CreatedCSSLinks;
    },
    addCSSLinks: function (cssLinks) {
        var _this = this;
        cssLinks && cssLinks.forEach(function (link) {
            if (!_this.AllCSSLinks.find(function (l) { return l.name === link.name || l.href === link.href; })) {
                _this.AllCSSLinks.push(link);
            }
        });
        return this.AllCSSLinks;
    }
};
//# sourceMappingURL=BlocksCSSLinkManager.js.map